import store from 'state/store';
import { sendOpenSearchLogs } from 'utils/helper-functions/send-open-search-logs.ts';

export const isCallbackLoad = (): boolean => {
  const { location } = store.getState();

  try {
    const url = new URL(location?.href);
    return Array.from(url?.searchParams?.keys())?.includes('callback');
  } catch (err) {
    const errorText = 'Cant parse url';

    sendOpenSearchLogs({
      event_group: 'processing_customer_data',
      error_data: {
        error: {
          message: errorText,
          stack: err,
        },
      },
    });

    console.error(errorText, err);
    return false;
  }
};
